import config from 'lib/config';
import { FavoritesResponse } from 'types/Apis/Favorites';
import authorizedFetch from 'lib/authorizedFetch';

async function fetchFavorites(): Promise<FavoritesResponse> {
  return authorizedFetch(`${config.coreApiUrl}/favorites`);
}

export default fetchFavorites;
